import React from 'react';
import {Box, FsH3, FsTypography} from '@aviatrix/flights';
import { IconAzure, IconAWSMarketplace, IconTF, IconCloudShell } from './SVGIcons';


type Category = "aws" | "azure" | "terraform" | "cloudshell";
type placeboxType = {
    category:Category,
    title?:string,
    label:string ,
    link?:string ,
    align?:string,
    width?:number,
    onClick?:()=>void
}

const CategoryIcon:any = {
    'aws':IconAWSMarketplace,
    'azure':IconAzure,
    'terraform':IconTF,
    'cloudshell':IconCloudShell
}

const linkStyle = {
    ':hover':{
        borderColor:'primary.main',
        cursor:'pointer!important'
    } 
}

const MarketPlaceBox = (props:placeboxType)=>{
    
    const getCSP = ()=>{
        return CategoryIcon[props.category]?CategoryIcon[props.category]:IconAzure;
    }

    function handlerClick(){
        if(props.link){
            window.open(props.link, '_blank');
        }else{
            if(props.onClick)
                props.onClick();
        }
    }

    return (
        <>
            <Box         
                sx={(theme) => ({
                    borderRadius:2,
                    borderWidth:'1px',
                    borderStyle:'solid',
                    borderColor:'background.light',
                    bgcolor:'background.light',
                    padding:'14px 14px 10px 14px',
                    textAlign:'center',
                    boxShadow:'0px 1px 1px 0px #231D305C',
                    width: props.width,
                    ...linkStyle,
                })}   
                onClick={handlerClick}
            >
                <Box display="flex" flexDirection="row" justifyContent="flex-start" gap={1} width="100%" >
                    <img src={getCSP()} style={{width:'36px',height:'36px', marginTop:'-4px'}}/>
                    {props.title? 
                        <>
                            <FsTypography variant="paragraph" align={'left' || props.align} margin={'-8px 0 0 0'}>
                                {props.title}
                                <br/><strong>{props.label}</strong>
                            </FsTypography>
                        </> 
                        : 
                        <FsH3 alignContent={props.align||'center'}>{props.label}</FsH3>
                    }
                    
                </Box>
            </Box>
        </>
    )
}

export default MarketPlaceBox;

